import React from "react";
import {
  ResponsiveContainer, AreaChart, Area, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
  BarChart, Bar, PieChart, Pie, Cell, Legend,
} from "recharts";

const tooltipStyle = {
  contentStyle: { background: "rgba(17,24,39,0.95)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12, color: "#F9FAFB" },
  labelStyle: { color: "#9CA3AF", fontWeight: 700, fontSize: 11, textTransform: "uppercase", letterSpacing: 1 },
  itemStyle: { color: "#F9FAFB" },
};

export const ReachLineChart = ({ data = [], color = "#A3E635" }) => (
  <ResponsiveContainer width="100%" height={260}>
    <LineChart data={data} margin={{ top: 10, right: 12, left: -12, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 6" stroke="rgba(255,255,255,0.05)" />
      <XAxis dataKey="date" stroke="#9CA3AF" tickLine={false} axisLine={false} fontSize={10} />
      <YAxis stroke="#9CA3AF" tickLine={false} axisLine={false} fontSize={10} />
      <Tooltip {...tooltipStyle} />
      <Line type="monotone" dataKey="reach" stroke={color} strokeWidth={2.5} dot={{ r: 3, fill: color }} />
    </LineChart>
  </ResponsiveContainer>
);

export const TrendChart = ({ data = [] }) => (
  <ResponsiveContainer width="100%" height={260}>
    <AreaChart data={data} margin={{ top: 10, right: 12, left: -12, bottom: 0 }}>
      <defs>
        <linearGradient id="gPurple" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#8B5CF6" stopOpacity={0.6} />
          <stop offset="100%" stopColor="#8B5CF6" stopOpacity={0} />
        </linearGradient>
        <linearGradient id="gCyan" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#22D3EE" stopOpacity={0.5} />
          <stop offset="100%" stopColor="#22D3EE" stopOpacity={0} />
        </linearGradient>
      </defs>
      <CartesianGrid strokeDasharray="3 6" stroke="rgba(255,255,255,0.05)" />
      <XAxis dataKey="month" stroke="#9CA3AF" tickLine={false} axisLine={false} />
      <YAxis stroke="#9CA3AF" tickLine={false} axisLine={false} />
      <Tooltip {...tooltipStyle} />
      <Area type="monotone" dataKey="payouts" stroke="#8B5CF6" strokeWidth={2.5} fill="url(#gPurple)" />
      <Area type="monotone" dataKey="submissions" stroke="#22D3EE" strokeWidth={2.5} fill="url(#gCyan)" />
    </AreaChart>
  </ResponsiveContainer>
);

const PIE_COLORS = ["#8B5CF6", "#22D3EE", "#A3E635", "#EC4899", "#F59E0B", "#10B981"];

export const CategoryPie = ({ data = [] }) => (
  <ResponsiveContainer width="100%" height={260}>
    <PieChart>
      <Tooltip {...tooltipStyle} />
      <Pie data={data} dataKey="value" nameKey="name" innerRadius={50} outerRadius={90} stroke="none" paddingAngle={2}>
        {data.map((slice, i) => <Cell key={slice.name} fill={PIE_COLORS[i % PIE_COLORS.length]} />)}
      </Pie>
      <Legend wrapperStyle={{ color: "#9CA3AF", fontSize: 12 }} />
    </PieChart>
  </ResponsiveContainer>
);

export const ProjectsBar = ({ data = [] }) => (
  <ResponsiveContainer width="100%" height={260}>
    <BarChart data={data} margin={{ top: 10, right: 12, left: -12, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 6" stroke="rgba(255,255,255,0.05)" />
      <XAxis dataKey="name" stroke="#9CA3AF" tickLine={false} axisLine={false} />
      <YAxis stroke="#9CA3AF" tickLine={false} axisLine={false} />
      <Tooltip {...tooltipStyle} />
      <Legend wrapperStyle={{ color: "#9CA3AF", fontSize: 11 }} />
      <Bar dataKey="approved" fill="#A3E635" radius={[6,6,0,0]} />
      <Bar dataKey="pending"  fill="#F59E0B" radius={[6,6,0,0]} />
      <Bar dataKey="rejected" fill="#EC4899" radius={[6,6,0,0]} />
    </BarChart>
  </ResponsiveContainer>
);

/** Horizontal bar chart used for distributions like Top Cities (rank-style). */
export const HorizontalBars = ({ data = [], color = "#22D3EE", height = 280 }) => (
  <ResponsiveContainer width="100%" height={height}>
    <BarChart data={data} layout="vertical" margin={{ top: 8, right: 20, left: 8, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 6" stroke="rgba(255,255,255,0.05)" horizontal={false} />
      <XAxis type="number" stroke="#9CA3AF" tickLine={false} axisLine={false} fontSize={10} />
      <YAxis type="category" dataKey="name" stroke="#9CA3AF" tickLine={false} axisLine={false} width={100} fontSize={11} />
      <Tooltip {...tooltipStyle} />
      <Bar dataKey="value" fill={color} radius={[0, 6, 6, 0]} />
    </BarChart>
  </ResponsiveContainer>
);